/**
This is the main language string collection object
 */
import BaseObject from "./Base.js"

export default class Language extends BaseObject {

	constructor() {
		super({
			type: 'content'
		});

		this.localStorageName = "Eiis-LanguageStrings";

		this.state = {};
		this.loading = true;
		this.loaded = false;

		this.loadContent();
	}

	loadContent() {
		this.state = {};
		if (localStorage.getItem(this.localStorageName)) {
			const records = JSON.parse(localStorage.getItem(this.localStorageName));
			for (let i = 0; i < records.length; i++) {
				const c = records[i];
				this.state[c.key] = c.content;
			}
			this.loaded = true;
			this.loading = false;
		} else {
			console.log("failed loading language!");
		}
	}

	get(key) {
		if (this.loaded === undefined || this.loaded === false) {
			this.loadContent();
		}

		if (this.state[key] === undefined) {
			console.log("failed looking up", key);
			return "||" + key + "||";
		}

		return this.state[key] || "||" + key + "||";
	}
}

